import React from 'react'
import { useIntl } from 'react-intl'
import DeleteIcon from '@mui/icons-material/Delete'
import IconButton from '../../components/Button/IconButton'
import TextField, {
	TextFieldProps,
} from '../../components/formControls/TextField'

export type EmailAddressFieldItemProps = TextFieldProps & {
	data: string
	onRemove?: () => void
}
const EmailAddressFieldItem = ({
	data,
	onRemove,
	...rest
}: EmailAddressFieldItemProps) => {
	const { formatMessage } = useIntl()
	return (
		<div className="flex items-end gap-3">
			<TextField
				fullWidth
				type="email"
				value={data}
				controlled={false}
				{...rest}
			/>
			<div className="ml-auto mb-4">
				<IconButton
					tooltipTitle={formatMessage({
						id: 'remove_record.remove',
					})}
					onClick={onRemove}
					color="error"
				>
					<DeleteIcon />
				</IconButton>
			</div>
		</div>
	)
}

export default EmailAddressFieldItem
